/** Сколько строк-скелетонов рисовать, пока грузится микрофронт. */
export const SKELETON_ROWS = 3

export const MESSAGES = {
  unregisteredTitle: 'Раздел ещё не подключён',
  unregisteredDescription:
    'Микрофронт живёт в отдельном репозитории и пока не зарегистрирован. Добавьте его в public/remotes.json или в переменную VITE_REMOTES — хост подхватит адрес без пересборки.',
  failedTitle: 'Не удалось загрузить раздел',
  failedDescription:
    'Микрофронт зарегистрирован, но его сборка не ответила. Проверьте, что он поднят и отдаёт remoteEntry.js.',
  retry: 'Повторить',
  crashedTitle: 'Раздел упал',
  crashedDescription: 'Ошибка внутри микрофронта. Остальное приложение продолжает работать.',
} as const
